import { PressPageTranslations } from "./types";

export const deTranslations: [PressPageTranslations] = [{
    title: "Plattform",
    quotes: [{
        subtitle: "Auszeichnung der Deutschen Ärztegesellschaft",
        description: "DIVINA wurde mit dem Deutschen Ärztepreis 2020 für seinen innovativen Ansatz ausgezeichnet, Medizinstudenten den Umgang mit komplexen Erkrankungen in Notaufnahmen beizubringen.",
    }]
}];